<script setup>
import Img from "@/components/Img.vue";
import { onMounted, nextTick } from 'vue'

const emits = defineEmits(['loadNextPage'])

const props = defineProps({
  id: { type: String, default: 'scrollable-list-container' },
  loading: { type: Boolean, default: false },
  length: { type: Number, default: 1 },
  emptyText: String,
  currentPage: { type: Number, required: true },
  lastPage: { type: Number, required: true },
  containerHeight: {type: String, default: '400px'}
})

const loadNextPage = () => {
  const container = document.getElementById(props.id);

  container.addEventListener('scroll', () => {
    if (container.scrollTop + container.clientHeight >= container.scrollHeight - 50) {
      if (!props.loading) {
        if(props.currentPage < props.lastPage){
          emits('loadNextPage', props.currentPage + 1);
        }
      }
    }
  });
};

onMounted(() => {
  nextTick(() => loadNextPage())
})

</script>

<template>
  <div :id="id" ref="table" class="table-container scroll-y p-5" :style="{ minHeight: containerHeight, maxHeight: containerHeight }">
    <div class="h-200px d-flex justify-content-center align-items-center" v-if="loading && !length">
      <div class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">{{ $t("loadingText") }}</span>
        </div>
      </div>
    </div>
    <div v-else-if="!length">
      <slot name="empty" />
      <div v-if="!$slots.empty" class="h-350px d-flex justify-content-center align-items-center" >
        <div class=" text-center ">
          <div class="pt-8 ">
            <Img filename="empty.png" alt=""
                 class="mw-100 h-125px h-sm-175px" />
          </div>
          <h2 class="fs-2x fw-bolder mb-0">{{ emptyText }}</h2>
        </div>
      </div>
    </div>
    <div v-else class="row p-7">
      <slot />
      <div class="h-200px d-flex justify-content-center align-items-center" v-if="loading && length">
        <div class="text-center">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">{{ $t("loadingText") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>